import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent {
    private _disabled: boolean;
    @Input()
    set disabled(disabled: boolean | '') {
        this._disabled = disabled === '' || disabled;
    }
    get disabled(): boolean | '' {
        return this._disabled;
    }

    @Input() expanded: any = false;
    @Input() icon = '';
    @Input() size = 'normal';
    @Input() type: 'button' | 'submit' | 'reset' = 'button';
    @Input() tabindex = '0';

    @Output() click = new EventEmitter<MouseEvent>();

    isActive = false;

    handleClick(event: Event): void {
        if (this.disabled) {
            event.cancelBubble = true;
            event.preventDefault();
        }
    }

    handleMouseDown(): void {
        this.isActive = true;
    }

    handleMouseUp(): void {
        this.isActive = false;
    }
}
